import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { ApiService } from "./api.service";
import { SearchResult } from "../models/search-result.model";
import { PetTagModel } from "../models/pet-tag.model";
import { PetTagListModel } from "../models/pet-tag-list.model";
import { AdmittedPetsModel } from "../models/admitted-pets.model";
import { PetTagHistModel } from "../models/pet-tag-hist.model";
import { PetProfileModel } from "../models/pet-profile.model";
import { PetRabieModel } from "../models/pet-rabie.model";
import { ClinicSublocationModel } from "../models/clinic-sublocation.model";
import { ClinicDeptModel } from "../models/clinic-dept.model";
import { DepartmentsModel } from "../models/departments.model";
import { ClinicLocationModel } from "../models/clinic-location.model";
import { PetTagDetailsModel } from "../models/pet-tag-details.model";

@Injectable({
    providedIn: "root"
})
export class TagService {

    private baseUrl: string = 'tag';
    private clinicUrl: string = 'clinic';

    current_pet_no: number = 0;

    get current_clinic(): number {
        return this.userData.clinic_no;
    }

    pet_tag: PetTagModel = new PetTagModel(0, 0, '', '', '', '');
    pet_tag_list: PetTagDetailsModel[] = [];
    pet_tag_hist: PetTagHistModel[] = [];
    pet_tag_hists: PetTagHistModel[] = [];
    pettaghist_data: PetTagHistModel = new PetTagHistModel(0, '', 0, '', 0, '', '', '', 0, 0, '', '', '');
    admitted_pets: AdmittedPetsModel[] = [];
    reserveTagsOnDate: PetTagHistModel[] = [];
    clinic_sublocation: ClinicSublocationModel[] = [];
    clinic_sublocation_single: ClinicSublocationModel = new ClinicSublocationModel(0, '', '', 0, '', 0, '', '', '', 0, 0);
    clinic_dept: ClinicDeptModel[] = [];
    clinic_dept_single: ClinicDeptModel = new ClinicDeptModel('', '', '', 0);
    departments: DepartmentsModel[] = [];
    departments_single: DepartmentsModel = new DepartmentsModel(0, '', '');

    setuptag_data: {id: number, pet_no: number, pet_name: string, location_id: number, sublocation_id: number, suffix: string, duration: number, date: string, status: string, department: string} = {id: 0, pet_no: 0, pet_name: '', location_id: 0, sublocation_id: 0, suffix: '', duration: 0, date: '', status: '', department: ''};

    
    private notifySetupTag = new Subject<{id: number, pet_no: number, pet_name: string, location_id: number, sublocation_id: number, suffix: string, duration: number, date: string, status: string, department: string}>();
    notifySetupTagObservable = this.notifySetupTag.asObservable();
    notifySetupTagFunction(setuptag_data: {id: number, pet_no: number, pet_name: string, location_id: number, sublocation_id: number, suffix: string, duration: number, date: string, status: string, department: string}) {
        this.notifySetupTag.next(setuptag_data);
    }

    private notifyUpdateTags = new Subject<void>();
    notifyUpdateTagsObservable = this.notifyUpdateTags.asObservable();
    notifyUpdateTagsFunction() {
        this.notifyUpdateTags.next();
    }

    get userData(): any {
        return JSON.parse(localStorage.getItem('currentUser') || '{}');
    }

    constructor(private api: ApiService) {}

    getTagByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getTagByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_tag = new PetTagModel(res.data.pet_no, res.data.profile_sequence, res.data.chip_no, res.data.rabie_tag_no, res.data.rabie_vacc_date, res.data.license_no);
                        resolve(1);
                    } else {
                        this.pet_tag = new PetTagModel(0, 0, '', '', '', '');
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetRabie() {
        this.pet_tag.pet_no = this.current_pet_no;

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetRabie`, this.pet_tag)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    clinic_location: ClinicLocationModel[] = [];

    getClinicLocation(clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getClinicLocation?clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.clinic_location = res.data.map((element: any) => {
                            return new ClinicLocationModel(element.location_id, (element.location_code || '').trim(), (element.location_desc || '').trim(), element.remarks, element.clinic_no);
                        });
                        resolve(1);
                    } else {
                        this.clinic_location = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetTagNo(tag_no: string) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/GetTagNo?tag_no=${tag_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                }, (error) => {
                    reject(error);
                });
        });
    }

    SetupTagNo(id: number, pet_no: number, pet_name: string, location_id: number, sublocation_id: number, suffix: string, duration: number, date: string, status: string, department: string) {
        const clinic_no = this.userData.clinic_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupTagNo?id=${id}&pet_no=${pet_no}&pet_name=${pet_name}&location_id=${location_id}&sublocation_id=${sublocation_id}&suffix=${suffix}&duration=${duration}&date=${date}&status=${status}&department=${department}&clinic_no=${clinic_no}&done_by=${this.userData.employee_name}`)
                .subscribe(
                    (res: any) => {
                        if (res && res.data) {
                            resolve(res.data);
                        } else {
                            resolve(0);
                        }
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
        return promise;
    }

    checkTagExists(location_id: number, sublocation_id: number, suffix: string): Promise<boolean> {
        return new Promise((resolve) => {
            this.api.get<string>(`${this.baseUrl}/CheckTagExists?location_id=${location_id}&sublocation_id=${sublocation_id}&suffix=${suffix}`)
                .subscribe((res: any) => {
                    resolve(res && res.data === true);
                }, () => resolve(false));
        });
    }

    async generateNextSuffix(location_id: number, sublocation_id: number, suffix: string = ''): Promise<string> {
        const exists = await this.checkTagExists(location_id, sublocation_id, suffix);
        if (!exists) return suffix;
        if (suffix === '') return this.generateNextSuffix(location_id, sublocation_id, 'b');
        return this.generateNextSuffix(location_id, sublocation_id, String.fromCharCode(suffix.charCodeAt(suffix.length - 1) + 1));
    }

    buildTagDisplay(location_code: string, sublocation_code: string, suffix: string, department: string): string {
        const tag = (location_code || '') + (sublocation_code || '') + (suffix || '');
        return department ? tag + '-' + department : tag;
    }

    GetPetTagList(tag_no: string, pet_no: number, pet_name: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetPetTagList?tag_no=${tag_no}&pet_no=${pet_no}&pet_name=${pet_name}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.pet_tag_list = res.data.map((element) => {
                            return new PetTagDetailsModel(element.tag_id, element.pet_no, element.pet_name, element.location_id, element.sublocation_id, element.suffix, element.department, element.done_by, element.clinic_no, element.tag_no, element.location_code, element.location_desc, element.sublocation_code, element.sublocation_desc);
                        });
                        resolve(1);
                    } else {
                        this.pet_tag_list = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetCurrentPetTag(pet_no: number) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/getCurrentPetTag?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        const element = res.data;
                        resolve(new PetTagDetailsModel(element.tag_id, element.pet_no, element.pet_name, element.location_id, element.sublocation_id, element.suffix, element.department, element.done_by, element.clinic_no, element.tag_no, element.location_code, element.location_desc, element.sublocation_code, element.sublocation_desc));
                    } else {
                        resolve(null);
                    }
                }, (error) => {
                    reject(error);
                });
        });
    }

    GetPetTagHistbyPetNo(pet_no: number) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/getPetTagHistbyPetNo?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                    this.pet_tag_hist = res.data.map((element) => {
                        const item = new PetTagHistModel(element.id, '', element.pet_no, element.pet_name, element.client_no, element.assign_date, element.done_date, element.location_code, element.sublocation_id, element.duration, element.status, element.department, element.done_by);
                        item.location_id = element.location_id;
                        item.location_code = element.location_code;
                        item.sublocation_id = element.sublocation_id;
                        item.sublocation_code = element.sublocation_code;
                        item.suffix = element.suffix;
                        item.clinic_no = element.clinic_no;
                        item.tag_no = element.tag_no || this.buildTagDisplay(element.location_code || '', element.sublocation_code || '', element.suffix || '', element.department);
                        return item;
                    });
                }, (error) => {
                    reject(error);
                });
        });
    }

    GetPetTagHistbyPetNoDate(pet_no: number, assign_date: string) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/getPetTagHistbyPetNoDate?pet_no=${pet_no}&assign_date=${assign_date}`)
                .subscribe((res: any) => {
                    const mapped = res.data ? res.data.map((element: any) => {
                        const item = new PetTagHistModel(element.id, '', element.pet_no, element.pet_name, element.client_no, element.assign_date, element.done_date, element.location_code, element.sublocation_id, element.duration, element.status, element.department, element.done_by);
                        item.location_id = element.location_id;
                        item.location_code = element.location_code;
                        item.sublocation_id = element.sublocation_id;
                        item.sublocation_code = element.sublocation_code;
                        item.suffix = element.suffix;
                        item.clinic_no = element.clinic_no;
                        return item;
                    }) : [];
                    resolve(mapped);
                }, (error) => {
                    reject(error);
                });
        });
    }

    GetClinicLocalTime(clinic_no: number): Promise<Date> {
        return new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClinicLocalTime?clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    resolve(new Date(res.data));
                }, (error) => {
                    reject(error);
                });
        });
    }

    checkReservedPetTag(location: string, sublocation: number, target_date: string) {
        let promise = new Promise((resolve) => {
            this.api.get(`${this.baseUrl}/checkReservedPetTag?location=${location}&sublocation=${sublocation}&target_date=${target_date}`)
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }

    GetAdmittedPets(clinic_no) {
        let NullValue: string = "";
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetAdmittedPets?clinic_no=${clinic_no}&tenant_no=${this.userData.tenant_no}&Pet_Name=${NullValue}&ClientName=${NullValue}&CheckIn=${NullValue}&Doctor=${NullValue}&Nurse=${NullValue}&Tag_Date=${NullValue}&location_id=0&sublocation_id=0`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.admitted_pets = res.data.map((element) => {
                            let taggeddate = this.ConvertTagNoteToDate2(element.tagdate);
                            return new AdmittedPetsModel(element.tag_id, element.pet_no, element.pet_name, element.location_id, element.sublocation_id, element.suffix, element.department, element.clinic_no, element.done_by, element.tag_display, element.location_code, element.location_desc, element.sublocation_code, element.sublocation_desc, element.checkedin, element.client_no, element.first_name, element.last_name, element.assigned_doctor, element.assigned_nurse1, taggeddate, element.sublocation_clinic_no);
                        });
                        resolve(1);
                    } else {
                        this.admitted_pets = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetAdmittedPetsSearch(clinic_no, Pet_Name: string, ClientName: string, CheckIn: string, Doctor: string, Nurse: string, Tag_Date: string, location_id: number, sublocation_id: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetAdmittedPets?clinic_no=${clinic_no}&tenant_no=${this.userData.tenant_no}&Pet_Name=${Pet_Name}&ClientName=${ClientName}&CheckIn=${CheckIn}&Doctor=${Doctor}&Nurse=${Nurse}&Tag_Date=${Tag_Date}&location_id=${location_id || 0}&sublocation_id=${sublocation_id || 0}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.admitted_pets = res.data.map((element) => {
                            let taggeddate = this.ConvertTagNoteToDate2(element.tagdate);
                            return new AdmittedPetsModel(element.tag_id, element.pet_no, element.pet_name, element.location_id, element.sublocation_id, element.suffix, element.department, element.clinic_no, element.done_by, element.tag_display, element.location_code, element.location_desc, element.sublocation_code, element.sublocation_desc, element.checkedin, element.client_no, element.first_name, element.last_name, element.assigned_doctor, element.assigned_nurse1, taggeddate, element.sublocation_clinic_no);
                        });
                        resolve(1);
                    } else {
                        this.admitted_pets = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetTagNoLookup(type: number, number: string) {
        let promise = new Promise((resolve, reject) => {
            if (type == 1) {
                this.api.get<SearchResult>(`${this.baseUrl}/gettagnolookup_1?number=${number}`)
                    .subscribe((res: any) => {
                        if (res && res.results > 0) {
                            let toreturn: PetRabieModel[] = res.data.map((element) => {
                                return new PetRabieModel(element.pet_no, element.rabie_tag_no, element.rabie_vacc_no, element.rabie_vacc_date, element.rabie_doctor, element.rabie_clinic, element.rabie_year, element.clinic_abbrev, element.pet_name);
                            });
                            resolve(toreturn);
                        }
                    });
            } else if (type == 2) {
                this.api.get<SearchResult>(`${this.baseUrl}/gettagnolookup_2?number=${number}`)
                    .subscribe((res: any) => {
                        if (res && res.results > 0) {
                            let toreturn: PetProfileModel[] = res.data.map((element) => {
                                return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff, element.pet_name);
                            });
                            resolve(toreturn);
                        }
                    });
            } else {
                this.api.get<SearchResult>(`${this.baseUrl}/gettagnolookup_3?number=${number}`)
                    .subscribe((res: any) => {
                        if (res && res.results > 0) {
                            let toreturn: PetTagListModel[] = res.data.map((element) => {
                                return new PetTagListModel(element.tag_no, element.pet_no, element.pet_name, element.location, element.sublocation, element.department, element.done_by);
                            });
                            resolve(toreturn);
                        }
                    });
            }
        });
        return promise;
    }

    async generateNextCode(existingCode: string): Promise<string> {
        const tagExists = await this.GetTagNo(existingCode);

        if (!tagExists) {
            return existingCode;
        }

        const lastChar = existingCode.charAt(existingCode.length - 1);
        let toreturn = '';

        if (!isNaN(parseInt(lastChar, 10))) {
            toreturn = existingCode + 'b';
        } else if (lastChar >= 'a' && lastChar <= 'z') {
            const newChar = String.fromCharCode(lastChar.charCodeAt(0) + 1);
            toreturn = existingCode.slice(0, -1) + newChar;
        } else {
            toreturn = existingCode + 'a';
        }

        return this.generateNextCode(toreturn);
    }

    ConvertTagNoteToDate2(tagNote) {
        if (tagNote == undefined || tagNote == '' || tagNote == null) {
            return '';
        }

        const datePattern = /(\d{1,2}\/\d{1,2}\/\d{2,4} \d{1,2}:\d{2}:\d{2} [APap][Mm])/;
        const matches = tagNote.match(datePattern);

        if (matches) {
            const dateTimeString = matches[0];
            const parsedDate = new Date(dateTimeString);
            const formattedDate = parsedDate.toLocaleString();
            return formattedDate;
        } else {
            return '';
        }
    }

    GetClinicSubLocationByLoc(location_id: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClinicSubLocationByLoc?location_id=${location_id}&clinic_no=${this.current_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.clinic_sublocation = res.data.map((element) => {
                            return new ClinicSublocationModel(element.sublocation_id, element.sublocation_code, element.sublocation_desc, element.specie, element.category, element.occupied, element.type, element.size, element.note, element.clinic_no, element.location_id);
                        });
                        resolve(1);
                    } else {
                        this.clinic_sublocation = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClinicSubLocation() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClinicSubLocationByLoc?clinic_dept_code=${0}&clinic_no=${this.current_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.clinic_sublocation = res.data.map((element) => {
                            return new ClinicSublocationModel(element.sublocation_id, element.sublocation_code, element.sublocation_desc, element.specie, element.category, element.occupied, element.type, element.size, element.note, element.clinic_no, element.location_id);
                        });
                        resolve(1);
                    } else {
                        this.clinic_sublocation = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetClinicSubLocationByLocAll(clinic_dept_code: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.clinicUrl}/GetClinicSubLocationByLoc?clinic_dept_code=${clinic_dept_code}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        resolve(res.data);
                    } else {
                        resolve([]);
                    }
                });
        });
        return promise;
    }

    getClinicDeptByCode(clinic_no: number, clinic_dept_code: string) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.clinicUrl}/GetClinicLocationByCode?clinic_dept_code=${clinic_dept_code}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                }, (error) => {
                    reject(error);
                });
        });
    }

    getClinicDept() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`catalog/?type=${16}&sequence=${this.current_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.clinic_dept = res.data.map((element) => {
                            return new ClinicDeptModel(element.clinic_dept, element.clinic_desc, (element.clinic_dept_code).replace(/\s/g, ""), element.clinic_no);
                        });
                        resolve(1);
                    } else {
                        this.clinic_dept = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClinicDeptByClinicNo(clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`catalog/?type=${16}&sequence=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.clinic_dept = res.data.map((element) => {
                            return new ClinicDeptModel(element.clinic_dept, element.clinic_desc, (element.clinic_dept_code).replace(/\s/g, ""), element.clinic_no);
                        });
                        resolve(1);
                    } else {
                        this.clinic_dept = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupClinicSublocation() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.clinicUrl}/SetupClinicSublocation`, this.clinic_sublocation_single)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    SetupLocation(actionType: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupLocation?clinic_dept=${this.clinic_dept_single.clinic_dept}&dept_desc=${this.clinic_dept_single.clinic_desc}&clinic_dept_code=${this.clinic_dept_single.clinic_dept_code}&clinic_no=${this.clinic_dept_single.clinic_no}&ActionType=${actionType}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    DeleteLocation(clinic_dept: string, clinic_dept_code: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.clinicUrl}/DeleteLocation?clinic_dept=${clinic_dept}&clinic_dept_code=${clinic_dept_code}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    DeleteSubLocation(sub_location: number, clinic_dept_code: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.clinicUrl}/DeleteSubLocation?sub_location=${sub_location}&clinic_dept_code=${clinic_dept_code}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    GetClinicDepartment() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.clinicUrl}/GetClinicDepartment`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.departments = res.data.map((element) => {
                            return new DepartmentsModel(element.dept_id, element.dept_desc, element.dept_note);
                        });
                        resolve(1);
                    } else {
                        this.departments = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupClinicSubloc_excel(exceldata: ClinicSublocationModel[]) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.clinicUrl}/SetupClinicSubloc_excel`, exceldata)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    SetupDepartment(OpType: number, dept_id: number, dept_desc: string, dept_note: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.clinicUrl}/SetupDepartment?OpType=${OpType}&dept_id=${dept_id}&dept_desc=${dept_desc}&dept_note=${dept_note}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    DeleteAllSublocation(clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.clinicUrl}/DeleteAllSublocation?clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    getTagsHistPerMonth(month: number, year: number, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getTagsHistPerMonth?month=${month}&year=${year}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_tag_hists = res.data.map((element) => {
                            const loc_code = (element.location_code || '').trim();
                            const item = new PetTagHistModel(element.ID, '', element.pet_no, element.pet_name, element.client_no, element.assign_date, element.done_date, loc_code, element.sublocation_id, element.duration, element.status, element.department, element.done_by);
                            item.location_id = element.location_id;
                            item.location_code = loc_code;
                            item.sublocation_id = element.sublocation_id;
                            item.sublocation_code = (element.sublocation_code || '').trim();
                            item.suffix = element.suffix || '';
                            item.clinic_no = element.clinic_no;
                            return item;
                        });
                        resolve(1);
                    } else {
                        this.pet_tag_hists = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetTagHistReserveTags(location_id: number, sublocation_id: number, assign_date: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetTagHistReserveTags?location_id=${location_id}&sublocation_id=${sublocation_id}&assign_date=${assign_date}&ts=${new Date().getTime()}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        this.reserveTagsOnDate = [];
                        resolve([]);
                    }
                });
        });
        return promise;
    }
}
